export default "__VITE_ASSET__g7fPr0Yz__";